import React from "react";
import StockoutProductPanel from './stockoutProductPanel.component';
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "modules/notification";
import { getDealerStockoutByProductData } from "modules/reporting/redux";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";

export default function StockoutProductPanelContainer({
    currentFilter,
    urlDealerStockoutProduct,
    translate,
    pageType
}){
    const dispatch = useDispatch();

    // (1) stockout product data -- start
    const isFetchingDealerStockoutByProduct = useSelector(state => selectLoading(state, getDealerStockoutByProductData.typePrefix));
    const dealerStockoutByProductData = useSelector(state => state.reporting.stockout.dealer.stockoutByProductData);
    // (1) stockout product data -- end
    
    const [tableFilter, setTableFilter] = useState({
        page: 0,
        rowsPerPage: 10,
        search: "",
        searchBy: "name",
        orderBy: "stockout_count",
        orderDirection: "desc",
    })

    useEffect(() => {
        dispatch(getDealerStockoutByProductData({
            length: tableFilter.rowsPerPage,
            start: tableFilter.page * tableFilter.rowsPerPage,
            orderBy: tableFilter.orderBy,
            orderDirection: tableFilter.orderDirection,
            search: tableFilter.search,
            searchBy: tableFilter.searchBy,
            branch_uuid: currentFilter.branchUuid,
            category_uuid: currentFilter.categoryUuid,
            brand_uuid: currentFilter.brandUuid,
            model_uuid: currentFilter.modelUuid,
            product_uuid: currentFilter.productUuid,
            period: currentFilter.period,
            start_date: moment(currentFilter.dateRange[0]).format('YYYY-MM-DD'),
            end_date: moment(currentFilter.dateRange[1]).format('YYYY-MM-DD'),
            url: urlDealerStockoutProduct
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, tableFilter, currentFilter]);

    const handleChangePage = (e, newPage) => {
        setTableFilter((prev) => ({
          ...prev,
          page: newPage,
        }))
    }

    const handleChangeRowPerPage = (event) => {
        setTableFilter((prev) => ({
          ...prev,
          page: 0,
          rowsPerPage: event.target.value
        }))
    }

    const handleRequestSort = (event, property) => {
        const isAsc = tableFilter.orderBy === property && tableFilter.orderDirection === 'asc';
        setTableFilter((prev) => ({
            ...prev,
            orderDirection: isAsc ? 'desc' : 'asc',
            orderBy: property,
        }))
    }

    return (
        <StockoutProductPanel 
            status={{
                isFetchingDealerStockoutByProduct
            }}

            data={{
                dealerStockoutByProductData
            }}

            sort={{
                valueToOrderBy: tableFilter.orderBy,
                orderDirection: tableFilter.orderDirection,
                handleRequestSort: handleRequestSort,
            }}

            pagination={{
                handleChangePage: handleChangePage,
                handleChangeRowPerPage: handleChangeRowPerPage,
                page: tableFilter.page,
                rowsPerPage: tableFilter.rowsPerPage,
                rowsPerPageOptions: [5, 10, 25],
            }}

            translate={translate}

            currentFilter={currentFilter}

            pageType={pageType}
        
        />
    )
}